import messages from "messages";

/**
 * get gad-7 rank by score
 */
export default function getGAD7ScoreRank(arg: number) {
  const res: {
    type: string;
    noticeable: boolean;
  } = {
    type: messages.severe,
    noticeable: false,
  };
  if (arg < 5) {
    res.type = messages.minimalAnxiety;
  } else if (arg < 10) {
    res.type = messages.mildAnxiety;
  } else if (arg < 15) {
    res.type = messages.moderateAnxiety;
  } else {
    res.type = messages.severeAnxiety;
    res.noticeable = true;
  }

  return res;
}
